import React from 'react';
import ContactSection from '../components/sections/ContactSection';

const ContactPage = () => {
  return (
    <div className="pt-20">
      <ContactSection />
    </div>
  );
};

export default ContactPage;